import React from "react";

const QRTicketInfoVMT = ({ ticket, payment }) => {

  const formatDate = (str) => {
    const d = new Date(str);
    return (
      String(d.getFullYear()).slice(-2) +
      String(d.getMonth() + 1).padStart(2, "0") +
      String(d.getDate()).padStart(2, "0")
    );
  };

  const formaTime = (str) => {
    const d = new Date(str);
    return (
      String(d.getHours()).padStart(2, "0") +
      ":" +
      String(d.getMinutes()).padStart(2, "0")
    );
  };


  return (
    <div style={styles.ticket}>

      <p style={styles.red}>
        <b>Повний</b> Електронний квиток сер. та №
        <br />
        {formatDate(payment.operationDate)}-{ticket.transpTerminal}-{ticket.shiftNum}-{ticket.num}
        <br />
        {formaTime(payment.operationDate)}
        <br />
        термін дії квитка до кінця рейсу
        <br />
        <br />
        Ціна <span style={styles.green}>{new Intl.NumberFormat('uk-UA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(ticket.amount)}</span> грн
        <span style={styles.red}> без ПДВ</span>
        <br />
        Міський/приміський маршрут ВМТГ № {ticket.routeCode}
        <br />
        Тролейбус/Трамвай/Автобус {ticket.vehicle}
      </p>

      <p style={{ ...styles.red, ...styles.small, ...styles.justify }}>
        Перевізник: КП «ВТК», Україна, 21036, Він. обл., Він. р-н, м. Вінниця, вул. <br />
        Хмельницьке шосе, 29, ІК: 03327925, тел.: 0432557839, 0674350525
        <br />
        Оператор АСООП: КП «ВІЦ», Україна, 21050, Він. обл., Він. р-н., м. <br />Вінниця,
        вул. Соборна, 64, ІК: 36365026, тел.: <b>0800330155</b>
        <br />
        <br />
        Договір страхування для автотранспорту від 12.05.2025р. № 1749-23/61.
        <br />
        Розмір страхової суми до 500000,0 грн
        <br />
        Страховик: ПАТ «УСК «Княжа Вієнна Іншуранс Груп», Україна, 04050,<br />
        м. Київ, вул. Глибочицька, 44, тел: 0800501486
      </p>

    </div>
  );
};

const styles = {
  ticket: {
    width: "350px",
    margin: "auto",
    textAlign: "center",
    fontFamily: "Arial"
  },

  red: { color: "black" },
  green: { color: "black" },
  yellow: { background: "yellow" },

  small: {
    fontSize: "10px",
    marginLeft: "5px"
  },

  justify: { textAlign: "justify" },

  qr: {
    width: "160px",
    height: "160px",
    border: "2px solid #888",
    margin: "30px auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
};

export default QRTicketInfoVMT;